import Constants from '../Constants';

export function getExperience(): string {
  const experienceContext: { [name: string]: string } = {};
  experienceContext.client_0 = Constants.Experiences.Ia.Clients;
  experienceContext.client_6 = Constants.Experiences.Investia.Clients;
  experienceContext.advisor_0 = Constants.Experiences.Ia.Advisors;
  experienceContext.advisor_6 = Constants.Experiences.Investia.Advisors;
  experienceContext.client_14 = Constants.Experiences.IaPrivateWealth.Clients;
  experienceContext.dealer_0 = Constants.Experiences.Ia.Dealers;
  experienceContext.partner_0 = Constants.Experiences.Ia.Partners;

  const contextKey = `${process.env.REACT_APP_CMS_USER_CONTEXT}_${process.env.REACT_APP_CMS_BUSINESS_ENTITY_CODE}`;

  return experienceContext[contextKey];
}
